export { PageHeroSection, type PageHeroSectionProps } from './PageHeroSection';
export { default } from './PageHeroSection';